import React from 'react';
import Tag from '~/components/Tag';
import style from './style.scss';

class UserPicker extends React.Component {
  static contextTypes = {
    dialogPush: React.PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { value, onChange, className, ...props } = this.props;
    return (
      <div {...props} className={[style.picker, className].join(' ')}>
        <Tag type="user" id={value || ''} onClick={() => this.context.dialogPush('userPick', { onChange })} />
        {value && <button
          className={style.pick}
          onClick={e => { e.preventDefault(); onChange(null); }}
        >x</button>}
      </div>
    );
  }
}

export default UserPicker;



// WEBPACK FOOTER //
// ./app/components/UserPicker/index.js